module.exports = __webpack_public_path__ + "img/skyteam-logo.f3a7d87e.png";